import React, { useEffect, useRef } from 'react';
import TextBox from 'devextreme-react/text-box';
import { AntLocalization } from 'ante-react-kit';
import EmployeeCard from './EmployeeCard';

const SEARCH_INPUT_ATTR = { autoFocus: true };

export default function SearchView({ query, onQueryChange, rows, loading, totalCount, loadMore, onPickCard, activeCode }) {
    const searchBoxRef = useRef(null);
    const bodyRef = useRef(null);

    useEffect(() => {
        const inst = searchBoxRef.current && searchBoxRef.current.instance;
        if (inst) {
            const t = setTimeout(() => {
                try {
                    inst.focus();
                } catch (e) {
                    /* ignore */
                }
            }, 50);
            return () => clearTimeout(t);
        }
    }, []);

    useEffect(() => {
        const marker = bodyRef.current;
        if (!marker) return;
        const scrollEl = marker.closest('.asp-shell__body') || marker;
        const onScroll = () => {
            if (scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 60) {
                if (rows.length < totalCount && !loading) loadMore();
            }
        };
        scrollEl.addEventListener('scroll', onScroll);
        return () => scrollEl.removeEventListener('scroll', onScroll);
    }, [rows.length, totalCount, loading, loadMore]);

    const empty = !loading && rows.length === 0;

    return (
        <div className="epk-shell">
            <div className="epk-search-header">
                <TextBox
                    ref={searchBoxRef}
                    value={query}
                    valueChangeEvent="input keyup change"
                    onValueChanged={(e) => onQueryChange(e.value || '')}
                    placeholder={AntLocalization.translateText({ vi: 'Tìm theo tên, mã, SĐT...', en: 'Search by name, code, phone...' })}
                    showClearButton={true}
                    inputAttr={SEARCH_INPUT_ATTR}
                    onEnterKey={() => {
                        if (rows.length === 1) onPickCard(rows[0]);
                    }}
                />
                <span className="epk-counter">{totalCount}</span>
            </div>
            <div className="epk-list" ref={bodyRef}>
                {loading && rows.length === 0 && (
                    <>
                        <div className="epk-skeleton" />
                        <div className="epk-skeleton" />
                        <div className="epk-skeleton" />
                    </>
                )}
                {empty && (
                    <div className="epk-empty">{AntLocalization.translateText({ vi: 'Không tìm thấy nhân viên', en: 'No employee found' })}</div>
                )}
                {rows.map((r) => (
                    <EmployeeCard key={r.id} row={r} isActive={activeCode && r.code === activeCode} onClick={onPickCard} />
                ))}
                {loading && rows.length > 0 && <div className="epk-loading-more">…</div>}
            </div>
        </div>
    );
}
